import { formatDecimal } from './formatDecimal';
import { formatNegative } from './formatNegative';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#signdisplay
export type FormatPriceSignDisplay = Exclude<Intl.NumberFormatOptionsSignDisplay, 'never' | 'always'>;

export type FormatPriceOptions = {
  displayCentsWhenLessThanDollar?: boolean;
  signDisplay?: FormatPriceSignDisplay;
};

export const formatPrice = (cents: number, options?: FormatPriceOptions) => {
  if (options?.displayCentsWhenLessThanDollar && Math.abs(cents) < 100) {
    const plusSign = options.signDisplay === 'exceptZero' && cents > 0 ? '+' : '';

    return formatNegative(`${plusSign}${cents}¢`);
  }

  const dollars = convertCentsToDollars(cents);
  const maximumFractionDigits = 2;
  const formattedPrice = formatDecimal(dollars, maximumFractionDigits);

  const formatterResult = new Intl.NumberFormat(['en-US'], {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
    signDisplay: options?.signDisplay,
  }).format(formattedPrice);

  return formatNegative(formatterResult);
};

export const convertCentsToDollars = (cents: number): number => cents / 100;

export const convertDollarsToCents = (dollars: number): number => dollars * 100;
